import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './car-or-van-availability.reducer';

export const CarOrVanAvailabilityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const carOrVanAvailabilityEntity = useAppSelector(state => state.carOrVanAvailability.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="carOrVanAvailabilityDetailsHeading">
          <Translate contentKey="apiLocationApp.carOrVanAvailability.detail.title">CarOrVanAvailability</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.date">Date</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllHouseholds">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.totalAllHouseholds">Total All Households</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.totalAllHouseholds}</dd>
          <dt>
            <span id="noCarsVans">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.noCarsVans">No Cars Vans</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.noCarsVans}</dd>
          <dt>
            <span id="oneCar">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.oneCar">One Car</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.oneCar}</dd>
          <dt>
            <span id="twoCars">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.twoCars">Two Cars</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.twoCars}</dd>
          <dt>
            <span id="threeOrMoreCars">
              <Translate contentKey="apiLocationApp.carOrVanAvailability.threeOrMoreCars">Three Or More Cars</Translate>
            </span>
          </dt>
          <dd>{carOrVanAvailabilityEntity.threeOrMoreCars}</dd>
        </dl>
        <Button tag={Link} to="/car-or-van-availability" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/car-or-van-availability/${carOrVanAvailabilityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CarOrVanAvailabilityDetail;
